var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoligonLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.73205C0.666667 4.96225 -3.38462e-07 4.57735 -3.77463e-07 4C-4.16465e-07 3.42265 0.666666 3.03775 2 2.26795L3.5 1.40192C4.83333 0.632123 5.5 0.247222 6 0.535898C6.5 0.824573 6.5 1.59437 6.5 3.13397L6.5 4.86602C6.5 6.40563 6.5 7.17543 6 7.4641C5.5 7.75278 4.83333 7.36788 3.5 6.59808L2 5.73205Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoligonLeft);
export default __webpack_public_path__ + "static/media/PoligonLeft.f8168e9fb3f5755768c94647664e6eb8.svg";
export { ForwardRef as ReactComponent };